module.exports = __webpack_public_path__ + "static/media/Refresh.a2fa8fcc.svg";